import controller from './chart-touch.controller';
import { template, bindings } from '../chart-abstract-base';

export default {
    bindings,
    template,
    controller
};
